import ActorInput from "./actorInput";
import useListActive from '../services/activeService';
import ActivesCount from "./activesCount";
import ActorDetails from "./actordetails";
import { Typography } from "@mui/material";
import useActor from "../services/actorService";
import { useState, useEffect, useContext } from "react";
import EventContext from "../store/event-context";
//import Alert from '@mui/material/Alert';
import AlertDialog from './alertDialog';
import { Backdrop, CircularProgress } from "@mui/material";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";

const ActorOut = () => {
  const {
    actorData,
    resetActor,
    isLoadingActor,
    actorServerError,
    fetchActor,
    actorStateChange,
  } = useActor();

  const { activeData, countActives, isLoadingActive, activeServerError, refresh } = useListActive();
  const [showAlert, setShowAlert] = useState(true);

  const eventctx = useContext(EventContext);
  const haveColor = eventctx.event.colors.length > 1;

  const searchLocalActor = (capnr, color) => {
    console.log(`Looking for actor ${color}:${capnr}`);
    fetchActor(color ? `${color}:${capnr}` : capnr);
  };

  //useEffect(() => {
  //  console.log("Resetting setShowAlert");
  //  setShowAlert(true);
  //}, [isLoadingActor, setShowAlert]);

  const afterCloseAlert = () => {
    resetActor();
    setShowAlert(true);
  }

  return (
    <Box height="100%" id="ActorOut">
      <Box id="ActorInputBox" sx={{marginTop: '10px'}}>
        {/* Below the input of Capnr.
            With in there the button (form submit) that calls "lookupactor" (here local searchLocalActor).
            In there it calls fetchFactor that finally updates actorData.
        */}
        <ActorInput lookupActor={searchLocalActor} isLoading={isLoadingActor} isDisabled={(actorData.state === "busy")} haveColor={haveColor} />
      </Box>
      <Box id="ActivesCount" sx={{marginTop: '10px', marginLeft: '10px'}}>
        <ActivesCount activesCount={countActives} refresh={refresh} />
      </Box>
      <Box height="80%" id="ActorOutResultBox">
        {/* Below the results of an actor.
            With in there the buttons [Uit het water] and [Cancel]
        */}
        <ActorDetails actor={actorData} actorStateChange={actorStateChange} clearActor={resetActor} refresh={refresh} />
      </Box>
      {actorServerError && showAlert && <AlertDialog
        onClose={afterCloseAlert}
        message={actorServerError}
        severity="warning"
        />}
      {/* {actorServerError && showAlert && (
        <Alert
          onClose={() => {
            setShowAlert(false);
          }}
          severity="error"
        >
          {actorServerError}
        </Alert>
      )}
      */}
      <Backdrop 
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoadingActor}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

export default ActorOut;
